import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/deploydog': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M382.2 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9v-103.9zM317.5 297.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.6 0-33.2 16.4-33.2 32.6zM188.5 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9v-103.9zM123.8 297.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.7 0-33.2 16.4-33.2 32.6zM448 96h-384c-17.6 0-32 14.5-32 32v256c0 17.6 14.5 32 32 32h384c17.6 0 32-14.5 32-32v-256c0-17.6-14.5-32-32-32zM448 64c35.2 0 64 28.8 64 64v256c0 35.2-28.8 64-64 64h-384c-35.2 0-64-28.8-64-64v-256c0-35.2 28.8-64 64-64h384z'
      }
    ]
  }
})
